// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"35c2c8fb","564":"b705752c","808":"08b26995"}[chunkId] + ".chunk.js";
};